/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * gringotts/v1/services/oauth_app_service.proto
 * OpenAPI spec version: version not set
 */

/**
 * OAuth grant type. UNSPECIFIED is treated as AUTHORIZATION_CODE (back-compat
with apps registered before this field existed).
 */
export type V1OAuthGrantType =
  (typeof V1OAuthGrantType)[keyof typeof V1OAuthGrantType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1OAuthGrantType = {
  OAUTH_GRANT_TYPE_UNSPECIFIED: 'OAUTH_GRANT_TYPE_UNSPECIFIED',
  OAUTH_GRANT_TYPE_AUTHORIZATION_CODE: 'OAUTH_GRANT_TYPE_AUTHORIZATION_CODE',
  OAUTH_GRANT_TYPE_CLIENT_CREDENTIALS: 'OAUTH_GRANT_TYPE_CLIENT_CREDENTIALS',
} as const;
